import { __awaiter as e, __generator as i } from "./index11.js";
var d = function(o, u) {
  return e(void 0, void 0, void 0, function() {
    var r;
    return i(this, function(c) {
      return r = function(a) {
        return e(void 0, void 0, void 0, function() {
          var n;
          return i(this, function(t) {
            switch (t.label) {
              case 0:
                return o(a) ? (n = r, [4, u()]) : [3, 2];
              case 1:
                return [2, n.apply(void 0, [t.sent()])];
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, [2, r(void 0)];
    });
  });
};
export {
  d as pWhile
};
//# sourceMappingURL=index63.js.map
